import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { S3IssuersEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const S3IssuersEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <S3IssuersEditCard
          id={Number(id)}
          client={Clients.S3}
          table_name={Tables.S3_ISSUERS}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.S3}
          audit_table_name={Tables.S3_ISSUERS}
        />
      </div>
    </div>
  );
};
